import { map } from 'lodash';

const endpoint = (property, event) => `/api/${property}/events/collect`;
const activeendpoint = (property, event) => `/api/${property}/events/collect/active`;
const groupedendpoint = (property) => `/api/${property}/events/collect/group`;
const crossendpoint = (property) => `/api/${property}/events/collect/cross`;
const categoryendpoint = (property) => `/api/${property}/events/collect/categories`;
const categoryFlatendpoint = (property) => `/api/${property}/events/collect/categories/flat`;
const relationendpoint = (property) => `/api/${property}/events/relation/update`;
const crossupdateendpoint = (property) => `/api/${property}/events/cross/update`;
const timesendpoint = (property) => `/api/${property}/events/times`;
const upgradesendpoint = (property) => `/api/${property}/events/collect/upgrades`;
const exclusionendpoint = (property, name, id) => `/api/${property}/events/${name}/${id}/exclusions`;
const visibilityendpoint = (property, name, id) => `/api/${property}/events/${name}/${id}/visibility`;
const offerendpoint = (property, name, id) => `/api/${property}/offer/${id}/${name}`;
const discountendpoint = (property, name, id) => `/api/${property}/discount/${id}/${name}`;
const optionsendpoint = (property) => `/api/${property}/events/options/update`;

export default ['api', '$rootScope', 'availabilityApiService', function (api, $rootScope, availabilityApiService) {
    return {
        collectAll: () => {
            return api.get(`${endpoint(api.property())}`)
                .then(response => response.data);
        },
        collectActive: (withCategories = false) => {
            let url = `${activeendpoint(api.property())}`;

            if (withCategories) {
                url += `?withCategories=true`;
            }

            return api.get(url)
                .then(response => response.data);
        },
        collectGrouped: () => {
            return api.get(`${groupedendpoint(api.property())}`)
                .then(response => response.data);
        },
        collectCategories: () => {
            return api.get(`${categoryendpoint(api.property())}`)
                .then(response => response.data);
        },
        collectCategoriesFlat: () => {
            return api.get(`${categoryFlatendpoint(api.property())}`)
                .then(response => response.data);
        },
        collectCross: type => {
            return api.get(`${crossendpoint(api.property())}/${type.toLowerCase()}`).then(response => response.data);
        },
        updateOptions: (dispatch) => {
            return api.post(`${optionsendpoint(api.property())}`, dispatch)
                .then(response => response.data);
        },
        updateRelated: (dispatch) => {
            return api.post(`${relationendpoint(api.property())}`, dispatch)
                .then(response => response.data);
        },
        updateCross: (dispatch) => {
            return api.post(`${crossupdateendpoint(api.property())}`, dispatch)
                .then(response => response.data);
        },
        collectUpgrades: () => {
            return api.get(`${upgradesendpoint(api.property())}`)
                .then(response => response.data);
        },
        updateTimes: (source, times) => {
            let dispatch = {
                'event_id': source.id,
                'event_type': source.type_raw,
                'days': map(source.days, 'day'),
                'times': times
            };
            return api.post(`${timesendpoint(api.property())}`, dispatch)
                .then(response => response.data);
        },
        updateExclusions: (id, data, name) => {
            return api.post(`${exclusionendpoint(api.property(), name, id)}`, data).then(response => response.data);
        },
        updateOptionVisibility: (id, data) => {
            return api.post(`${visibilityendpoint(api.property(), 'options', id)}`, data).then(response => response.data);
        },
        updateExtraVisibility: (id, data) => {
            return api.post(`${visibilityendpoint(api.property(), 'extras', id)}`, data).then(response => response.data);
        },
        updateOffer: (id, data, name) => {
            return api.post(`${offerendpoint(api.property(), name, id)}`, data).then(response => response.data);
        },
        updateDiscount: (id, data, name) => {
            return api.post(`${discountendpoint(api.property(), name, id)}`, data).then(response => response.data);
        },
        collectCustomisations: (eventType, eventId) => {
            return api.get(`/api/${api.property()}/${availabilityApiService.switchEventType(eventType)}/${eventId}/customisations`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/events.service.js